import React from 'react';
import { Button } from 'react-bootstrap';
import styled from 'styled-components';

export const NotificationTabContainer = styled.div`
  .nav-tabs {
    display: flex;
    justify-content: center;
    background-color: #f7fbfe;
    border-radius: 10px;
    padding: 2px;
    border:none !important;
  }

  .nav-item {
    display: flex;
    align-items: center; /* Center vertically */
  }

  .nav-item .nav-link.active {
    color: #fff;
    background: #002694;
    border-radius: 13.899px;
    font-size: 8.002px !important;
    width: 51.476px;
    height: 25.413px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.24px;
    align-items: center;
  }

  .nav-item .nav-link {
    color: #002694;
    font-size: 8.002px !important;
    width: 51.476px;
    height: 25.413px;
    border-radius: 13.899px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: -0.24px;
  }
`;

export const HorizontalLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: rgba(0, 38, 148, 0.50);
`;
export const ViewAllButton = styled(Button)`
&&&{
    background: #002694 !important;
    font-family: Poppins !important;
    font-size: 12px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: normal !important;
    letter-spacing: -0.18px !important;
    padding: 7px 12px !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 6px !important;
}
`;
export const MarkReadButton = styled(ViewAllButton)`
&&&{
    color: #002694 !important;
    background:#fff !important;
}
`;
export const LoadMoreButton = styled(MarkReadButton)`
&&&{
    width: 100%;
    border: 1px solid rgba(0, 38, 148, 0.30) !important;
}
`;
export const NotificationMessageContainer = styled.div`
    padding:8px 10px;
    width: 100%;
    flex-shrink: 0;
    border-radius: 2.059px;
    background: #F7FBFE;
    &.clickable{
        cursor: pointer;
    }
    &.clickable:hover{
        background: #EDF5FD;
    }
    /* Unread is the only state the badge is derived from, so it has to be visible. */
    &.unread{
        background: #FFF;
        border-left: 2px solid #002694;
    }
    .MessageHeader{
        color: #002694;
        font-family: Poppins;
        font-size: 13px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.35;
        letter-spacing: -0.24px;
    }
    &.unread .MessageHeader{
        font-weight: 700;
    }
    .unread-dot{
        display: inline-block;
        width: 6px;
        height: 6px;
        margin-right: 5px;
        border-radius: 50%;
        background: #3EB3FF;
        vertical-align: middle;
    }
    .MessageBody{
        color: #647084;
        font-family: Poppins;
        font-size: 11.5px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.45;
        letter-spacing: -0.18px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .datetime{
        color: #3EB3FF;
        font-family: Poppins;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.18px;
    }
`;
